import request from '@/utils/request'

export function getMallCommunityList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.queryMallCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
